import { debug } from 'settings/custom/build'

const jackpot = false // todo jackpot BE fetch

const info = {
  debug,
  jackpot,
}

export const Context = { validate }

function validate({ context }) {
  return Object.entries(context || {}).every(([key, value]) => info[key] == value)
}
